import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1ffd0ef8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", {
    "class": "mb-8 text-3xl font-bold"
  }, "Hirearchy", -1);
});
var _hoisted_2 = {
  "class": "w-full h-full bg-white rounded-md shadow"
};
var _hoisted_3 = {
  "class": "hello",
  ref: "chartDiv",
  style: {
    "font-family": "'Lato',sans-serif !important"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Hirearchy"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, null, 512)])]);
}